// src/components/FooterNav.js
import React from "react";
import { NavLink } from "react-router-dom";
import { FaUser, FaFileAlt, FaProjectDiagram, FaCode, FaEnvelope } from "react-icons/fa";
import "./FooterNav.css";

export default function FooterNav() {
  return (
    <footer className="footer-nav">
      <NavLink to="/about" className="nav-item">
        <FaUser />
        <span>About</span>
      </NavLink>
      <NavLink to="/experience" className="nav-item">
        <FaFileAlt />
        <span>Experience</span>
      </NavLink>
      <NavLink to="/skills" className="nav-item">
        <FaCode />
        <span>Skills</span>
      </NavLink>
      <NavLink to="/portfolio" className="nav-item">
        <FaProjectDiagram />
        <span>Portfolio</span>
      </NavLink>
      <NavLink to="/contact" className="nav-item">
        <FaEnvelope />
        <span>Contact</span>
      </NavLink>
    </footer>
  );
}
